import React from "react";
import { SelectButton } from "primereact/selectbutton";
import useTranslation from "../../i18n/useTranslation";
import "./LanguageSwitcher.scss";

// Language codes are shown verbatim in both languages - no flags (a language is not a country).
const OPTIONS = [
   { label: "PL", value: "pl" },
   { label: "EN", value: "en" }
];

// Holds no local state: the value comes straight from the i18n context, so the highlight stays
// correct even though the header remounts on navigation.
export default function LanguageSwitcher() {
   const { t, locale, setLocale } = useTranslation();

   return (
      <SelectButton
         value={locale}
         options={OPTIONS}
         optionLabel="label"
         optionValue="value"
         onChange={(event) => event.value && setLocale(event.value)}
         className="language-switcher"
         aria-label={t("common.language")}
      />
   );
}
